import { useGetAgencyUsersQuery } from '@/modules/agencies/api/agenciesApi'
import { getAuthErrorMessage } from '@/utils/getAuthErrorMessage'

export function useAgencyUsers(agencyId: string | null) {
  const { data, isLoading, isError, error } = useGetAgencyUsersQuery(
    { agencyId: agencyId ?? '' },
    { skip: !agencyId },
  )

  return {
    users: data ?? [],
    isLoading: Boolean(agencyId) && isLoading,
    isError,
    errorMessage: isError ? getAuthErrorMessage(error) : null,
    isEmpty: !isLoading && !isError && (data?.length ?? 0) === 0,
  }
}
